// Hook for PWA Badges
import { useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Set the app badge count (PWA)
 * @param {number} count - The number to display
 */
const setAppBadge = async (count) => {
    if ('setAppBadge' in navigator) {
        try {
            if (count > 0) {
                await navigator.setAppBadge(count);
            } else {
                await navigator.clearAppBadge();
            }
        } catch (e) {
            console.error('Error setting app badge:', e);
        }
    }
};

/**
 * Clear the app badge
 */
const clearAppBadge = async () => {
    if ('clearAppBadge' in navigator) {
        try {
            await navigator.clearAppBadge();
        } catch (e) {
            console.error('Error clearing app badge:', e);
        }
    }
};

/**
 * Hook to manage PWA App Badge based on unread notifications
 * @param {Object} user - Current user object
 */
export const useAppBadge = (user) => {
    useEffect(() => {
        if (!user?.uid) {
            setAppBadge(0);
            return;
        }

        // Subscribe to unread notifications count
        const notificationsRef = collection(db, 'notifications');
        const q = query(
            notificationsRef,
            where('userId', '==', user.uid),
            where('read', '==', false)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const count = snapshot.size;
            setAppBadge(count);
        }, (error) => {
            console.error("Error syncing app badge:", error);
        });

        return () => unsubscribe();
    }, [user]);
};
